import { useEffect } from 'react';

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // Use 'smooth' for smooth scrolling, or 'auto' for instant scrolling
    });
  }, []);
};

export default useScrollToTop;
